// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

import { Link } from "@tanstack/react-router";

import { AuthLayout, linkClass } from "../components/AuthLayout.js";
import { t } from "../lib/i18n.js";

export function NotFoundPage() {
  return (
    <AuthLayout title={t("notFound.title")}>
      <p className="mb-4 text-sm text-fg-muted">{t("notFound.body")}</p>
      <Link to="/" className={linkClass}>
        {t("notFound.home")}
      </Link>
    </AuthLayout>
  );
}
